<template>
  <div class="tab animated" v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "GrowerWebBaseTab",
  props: {
    title: {
      type: String,
      default: "Tab",
    },
  },

  data() {
    return {
      isActive: true,
    };
  },

  mounted() {},

  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/base/component/base-tab.vue